export default "__VITE_ASSET__CWobbDEm__"